"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowContainer = void 0;
var react_1 = __importStar(require("react"));
var useArrowContainer_1 = require("./useArrowContainer");
var ArrowContainer = function (_a) {
    var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position, arrowColor = _a.arrowColor, arrowSize = _a.arrowSize, externalArrowStyle = _a.arrowStyle, className = _a.className, children = _a.children, externalArrowContainerStyle = _a.style;
    var _b = useArrowContainer_1.useArrowContainer({
        childRect: childRect,
        popoverRect: popoverRect,
        position: position,
        arrowColor: arrowColor,
        arrowSize: arrowSize,
    }), arrowContainerStyle = _b.arrowContainerStyle, arrowStyle = _b.arrowStyle;
    var mergedContainerStyle = react_1.useMemo(function () { return (__assign(__assign({}, arrowContainerStyle), externalArrowContainerStyle)); }, [arrowContainerStyle, externalArrowContainerStyle]);
    var mergedArrowStyle = react_1.useMemo(function () { return (__assign(__assign({}, arrowStyle), externalArrowStyle)); }, [arrowStyle, externalArrowStyle]);
    return (react_1.default.createElement("div", { className: className, style: mergedContainerStyle },
        react_1.default.createElement("div", { style: mergedArrowStyle }),
        children));
};
exports.ArrowContainer = ArrowContainer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXJyb3dDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvQXJyb3dDb250YWluZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUF1QztBQUV2Qyx5REFBd0Q7QUFFakQsSUFBTSxjQUFjLEdBQWtDLFVBQUMsRUFVN0Q7UUFUQyxTQUFTLGVBQUEsRUFDVCxXQUFXLGlCQUFBLEVBQ1gsUUFBUSxjQUFBLEVBQ1IsVUFBVSxnQkFBQSxFQUNWLFNBQVMsZUFBQSxFQUNHLGtCQUFrQixnQkFBQSxFQUM5QixTQUFTLGVBQUEsRUFDVCxRQUFRLGNBQUEsRUFDRCwyQkFBMkIsV0FBQTtJQUU1QixJQUFBLEtBQXNDLHFDQUFpQixDQUFDO1FBQzVELFNBQVMsV0FBQTtRQUNULFdBQVcsYUFBQTtRQUNYLFFBQVEsVUFBQTtRQUNSLFVBQVUsWUFBQTtRQUNWLFNBQVMsV0FBQTtLQUNWLENBQUMsRUFOTSxtQkFBbUIseUJBQUEsRUFBRSxVQUFVLGdCQU1yQyxDQUFDO0lBRUgsSUFBTSxvQkFBb0IsR0FBRyxlQUFPLENBQ2xDLGNBQU0sT0FBQSx1QkFDRCxtQkFBbUIsR0FDbkIsMkJBQTJCLEVBQzlCLEVBSEksQ0FHSixFQUNGLENBQUMsbUJBQW1CLEVBQUUsMkJBQTJCLENBQUMsQ0FDbkQsQ0FBQztJQUVGLElBQU0sZ0JBQWdCLEdBQUcsZUFBTyxDQUM5QixjQUFNLE9BQUEsdUJBQ0QsVUFBVSxHQUNWLGtCQUFrQixFQUNyQixFQUhJLENBR0osRUFDRixDQUFDLFVBQVUsRUFBRSxrQkFBa0IsQ0FBQyxDQUNqQyxDQUFDO0lBRUYsT0FBTyxDQUNMLHVDQUFLLFNBQVMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLG9CQUFvQjtRQUNwRCx1Q0FBSyxLQUFLLEVBQUUsZ0JBQWdCLEdBQUk7UUFDL0IsUUFBUSxDQUNMLENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQXpDVyxRQUFBLGNBQWMsa0JBeUN6QiJ9